module.exports = "<span style=\"cursor: pointer;\" (click)=\"onClick()\">{{ params.data.ShiftName }}</span>"